/**
 * Returns `true` when the Node environment is not 'production'.
 */
export default () => useRuntimeConfig().public.isDevelop;
